import { createApp } from 'vue'
import __t from "../../../../helpers/translate";
import fmtDate from "../../../../helpers/fmtDay";
import vue_helpers from "../../../../helpers/check_null";
import {createBootstrap} from 'bootstrap-vue-next';
import protocol_table from "./protocol_table.vue";

window.PROTOCOLS_LIST = createApp({
    name : "PROTOCOLS_LIST_VUE",
    id : "PROTOCOLS_LIST_VUE",
    components : {
        protocol_table : protocol_table,
    }
})
    .mixin(__t)
    .mixin(vue_helpers)
    .mixin(fmtDate)
    .use(createBootstrap())
    .use(v_store);

PROTOCOLS_LIST.mount('#protocol_table');